import React from "react";
import PropTypes from "prop-types";
import { FeaturesTable } from "@components";
import InfoPlanAsistencia from "./InfoPlanAsistencia";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import { isEmpty, isUndefined } from "lodash";

PlanAsistencia.propTypes = {
  dataPlan: PropTypes.array,
};

const ROOT = process.env.REACT_APP_CMS_STATIC;

function PlanAsistencia({ dataPlan = [], ...props }) {
  const RUTA_PREVIA = dataPlan[0]?.rutaPrevia[0] && dataPlan[0]?.rutaPrevia[0];

  const RUTA = dataPlan[0]?.ruta?.contentItems[0];
  const BOTONES = dataPlan[0]?.botones?.contentItems;

  /*const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });*/

  const detailTitleStyle = {
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  };

  const itemsBreadcrumb = () => {
    return !isUndefined(RUTA_PREVIA)
      ? [RUTA_PREVIA]
      : [{ url: RUTA && RUTA?.url, text: RUTA && RUTA?.name }];
  };

  const renderCompreAqui = () => {
    const showInDetail =
      BOTONES && BOTONES.filter((btn) => btn.mostrarEnDetalle !== false);
    const showCompre = showInDetail?.filter(
      (sid) =>
        sid.displayText.includes("Compr") || sid.displayText.includes("Consult")
    );
    return !isEmpty(showCompre) ? showCompre[0] : null;
  };

  const files =  dataPlan[0].archivosDescargables?.contentItems
    ? dataPlan[0].archivosDescargables?.contentItems.map(
        (file) => {
            return {
              fileName: file.tituloEnlace,
              fileURL: ROOT + file.archivo.urls[0],
            };
        }
     ) : [];

  return (
    <div className="pt-5 pb-4">
      <Meta 
        title={RUTA?.title + " | Planes de Asistencia | CS Ahorro y Crédito"} 
        description={RUTA?.description} 
      />
      <Breadcrumbs items={itemsBreadcrumb()} active={RUTA?.title} />
      {dataPlan && (
        <InfoPlanAsistencia
          titulo={dataPlan[0]?.titulo}
          nombrePlan={dataPlan[0]?.nombre}
          urlImagen={ROOT + dataPlan[0]?.imagen?.urls[0]}
          tituloDescripcion={dataPlan[0]?.tituloDescripciongeneral}
          textoDescripcion={dataPlan[0]?.textoDescripciongeneral?.html}
          tituloCosto={dataPlan[0]?.tituloCostodelaasistencia}
          textoCosto={dataPlan[0]?.textoCostodelaasistencia?.html}
          botonCompreAqui={renderCompreAqui()}
        />
      )}

      {!isEmpty(dataPlan[0]?.serviciosAsistencia?.contentItems) && (
        <FeaturesTable
          headers={[
            {
              title: "Servicio",
              columnWidthPct: "50%",
              columnWidthPhonePct: "40%",
            },
            {
              title: "Límite de suma",
              columnWidthPct: "25%",
              columnWidthPhonePct: "30",
            },
            {
              title: "Eventos",
              columnWidthPct: "25%",
              columnWidthPhonePct: "30",
            },
          ]}
          rows={dataPlan[0]?.serviciosAsistencia?.contentItems}
          footnote={
            !isEmpty(dataPlan[0]?.notaAlPie) && dataPlan[0]?.notaAlPie?.html
          }
        />
      )}
      
      { files && files.length > 0 && (
         <div className="membership-container">
            <CardTypeFolder
              titleStyle={detailTitleStyle}
              title="Documentos"
              description=""
              files={files}
              borderTopColor="#d7de00"
            />
         </div>
      )}

      {!isUndefined(BOTONES) && (
        <div className="button-container-pa">
          {BOTONES &&
            BOTONES.map((button, index) => {
              return (
                button.mostrarEnDetalle && (
                  <div key={index} className="btn-size-pa">
                    <a
                      className="anchor"
                      href={button?.ruta?.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={ROOT + button.imagen?.urls[0]}
                        className="img"
                        alt={button.displayText}
                      />
                    </a>
                  </div>
                )
              );
            })}
        </div>
      )}
    </div>
  );
}

export default PlanAsistencia;
